<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 16:31:55
-->
<template>
  <div class="douKuaiCell">
      <span v-if="row[column.key]">已失效</span>
      <a :href="row['download_url']" v-if="row['export_status'] === 1 && !row[column.key]">下载</a>
      <span class="mr-8" v-if="row['export_status'] !== 1">--</span>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped>
.state_icon{
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.success{
    background-color: @color-success;
}
.danger{
    background-color: @color-danger;
}
</style>